var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.isLoading)?_c('div',{attrs:{"id":"app"}},[(_vm.shouldRenderLayout)?_c('div',[_c('HeaderBar'),_c('div',{staticClass:"main-container d-lg-flex"},[_c('SideMenu'),_c('router-view')],1)],1):_c('div',[_c('router-view')],1)]):_c('loading-view')
}
var staticRenderFns = []

export { render, staticRenderFns }